import { AppState } from '../index';

export const getWishListPublicSelector = (state: AppState) => {
   return state.wishListPublic;
};